<template>
    <h1>📊 Tableau Croisé Dynamique</h1>
    
    <!-- Tableau croisé -->
    <PivotTable 
      :data="sampleData"
      :available-fields="availableFields"
    />
    
    <!-- Visualisations -->
    <div class="visualizations" v-if="showCharts">
      <PivotChart :pivot-data="pivotData" />
    </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import PivotTable from './components/PivotTable.vue'
// import PivotChart from './components/PivotChart.vue'

// Données d'exemple
const sampleData = ref([
  { region: 'Nord', produit: 'TV', mois: 'Janvier', ventes: 15000, quantite: 50 },
  { region: 'Nord', produit: 'TV', mois: 'Février', ventes: 18000, quantite: 60 },
  { region: 'Sud', produit: 'TV', mois: 'Janvier', ventes: 12000, quantite: 40 },
  { region: 'Sud', produit: 'TV', mois: 'Février', ventes: 14000, quantite: 45 },
  { region: 'Nord', produit: 'Radio', mois: 'Janvier', ventes: 5000, quantite: 100 },
  { region: 'Nord', produit: 'Radio', mois: 'Février', ventes: 6000, quantite: 120 },
  { region: 'Sud', produit: 'Radio', mois: 'Janvier', ventes: 4000, quantite: 80 },
  { region: 'Sud', produit: 'Radio', mois: 'Février', ventes: 4500, quantite: 90 },
])

// Champs disponibles
const availableFields = ref([
  { name: 'region', label: 'Région', type: 'category' },
  { name: 'produit', label: 'Produit', type: 'category' },
  { name: 'mois', label: 'Mois', type: 'string' },
  { name: 'ventes', label: 'Ventes (€)', type: 'currency' },
  { name: 'quantite', label: 'Quantité', type: 'number' }
])

const showCharts = ref(true)
</script>

<style>
.app {
  max-width: 1400px;
  margin: 0 auto;
  padding: 20px;
}

h1 {
  color: #2c3e50;
  text-align: center;
  margin-bottom: 30px;
  padding-bottom: 15px;
  border-bottom: 3px solid #4a6fa5;
}

.visualizations {
  margin-top: 40px;
  padding: 20px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}
</style>